export default "__VITE_ASSET__CEVF8qtT__"